import {
  useMediaQuery as MuiUseMediaQuery,
  CssBaseline as MuiCssBaseline,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material'
import {
  createTheme as muiCreateTheme,
  useTheme as MuiUseTheme,
  styled as muiStyled,
  responsiveFontSizes as muiResponsiveFontSizes,
  type Theme as MuiTheme,
  type SxProps as MuiSxProps,
  type CSSInterpolation as MuiCSSInterpolation,
} from '@mui/material/styles'

export const useTheme = MuiUseTheme
export const useMediaQuery = MuiUseMediaQuery
export const styled = muiStyled
export const CssBaseline = MuiCssBaseline
export const ThemeProvider = MuiThemeProvider
export const createTheme = muiCreateTheme
export const responsiveFontSizes = muiResponsiveFontSizes

export type Theme = MuiTheme
export type SxProps = MuiSxProps
export type CSSInterpolation = MuiCSSInterpolation
